"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _findIndex2 = _interopRequireDefault(require("lodash/findIndex"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _set2 = _interopRequireDefault(require("lodash/set"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _WorkflowContext = require("./WorkflowContext");

var _WorkflowConsumer = _interopRequireDefault(require("./WorkflowConsumer"));

var _WorkflowStepList = _interopRequireDefault(require("./WorkflowStepList"));

var _WorkflowStep = _interopRequireDefault(require("./WorkflowStep"));

var _WorkflowStepIdButton = _interopRequireDefault(require("./WorkflowStepIdButton"));

var _WorkflowNextButton = _interopRequireDefault(require("./WorkflowNextButton"));

var _WorkflowPreviousButton = _interopRequireDefault(require("./WorkflowPreviousButton"));

var _WorkflowDebugInfo = _interopRequireDefault(require("./WorkflowDebugInfo"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint react/no-unused-state: 0 */

/* eslint react/sort-comp: 0 */
var Workflow = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Workflow, _React$Component);

  var _super = _createSuper(Workflow);

  function Workflow() {
    var _this;

    (0, _classCallCheck2.default)(this, Workflow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", function () {
      _this.setState({
        workflowDidMount: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "registerStepListImplRef", function (stepListImplRef) {
      setTimeout(function () {
        _this.setState({
          stepListImplRef: stepListImplRef
        });
      }, 1);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "goToStep", function (_ref) {
      var stepId = _ref.stepId,
          nextStepIdOverride = _ref.nextStepIdOverride,
          previousStepIdOverride = _ref.previousStepIdOverride;

      _this.setState({
        // This is to make it unique, avoiding the situation we get redirected to the previous step right before it gets unmounted
        goToStepCallCount: _this.state.goToStepCallCount + 1,
        currentStepId: stepId,
        previousStepId: _this.state.currentStepId,
        nextStepIdOverride: nextStepIdOverride,
        previousStepIdOverride: previousStepIdOverride
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getStepIds", function () {
      var impl = _this.state.stepListImplRef ? _this.state.stepListImplRef.current : undefined;

      if (impl) {
        return impl.getStepIds();
      }

      return [];
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getNextStepId", function (stepId) {
      if (_this.state.nextStepIdOverride) {
        return _this.state.nextStepIdOverride;
      }

      var impl = _this.state.stepListImplRef ? _this.state.stepListImplRef.current : undefined;

      if (impl) {
        return impl.getNextStepId(stepId);
      }

      return undefined;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getPreviousStepId", function (stepId) {
      if (_this.state.previousStepIdOverride) {
        return _this.state.previousStepIdOverride;
      }

      var impl = _this.state.stepListImplRef ? _this.state.stepListImplRef.current : undefined;

      if (impl) {
        return impl.getPreviousStepId(stepId);
      }

      return undefined;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "beginTransition", function (_ref2) {
      var transitionName = _ref2.transitionName,
          transitionTimeout = _ref2.transitionTimeout;

      _this.setState({
        transitionName: transitionName,
        transitionTimeout: transitionTimeout,
        isTransitioning: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "endTransition", function () {
      _this.setState({
        isTransitioning: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setStepExtendedState", function (stepId, path, value) {
      var fullPath = "extendedStateByStepId.".concat(stepId, ".").concat(path);
      var stateChange = (0, _set2.default)({}, fullPath, value);

      _this.setState(stateChange);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getStepExtendedState", function (stepId, path) {
      var fullPath = "extendedStateByStepId.".concat(stepId, ".").concat(path);
      return (0, _get2.default)(_this.state, fullPath);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getStatus", function () {
      var impl = _this.state.stepListImplRef ? _this.state.stepListImplRef.current : undefined;
      var perStepProps;

      if (impl) {
        perStepProps = impl.getArrayOfStepProps();
      }

      var numberOfSteps = perStepProps ? perStepProps.length : 0;
      var perStepSummary = (perStepProps || []).map(function (stepProps) {
        var stepExtendedState = stepProps.stepId ? _this.state.extendedStateByStepId[stepProps.stepId] : {};
        return {
          props: stepProps,
          extendedState: stepExtendedState
        };
      });
      var currentStepIndex;
      var currentStepProps;
      var previousStepIndex;

      if (perStepProps && _this.state.currentStepId) {
        currentStepIndex = (0, _findIndex2.default)(perStepProps || [], function (stepProps) {
          return stepProps.stepId === _this.state.currentStepId;
        });

        if (currentStepIndex > -1) {
          currentStepProps = perStepProps[currentStepIndex];
        }

        previousStepIndex = (0, _findIndex2.default)(perStepProps || [], function (stepProps) {
          return stepProps.stepId === _this.state.previousStepId;
        });
      }

      return {
        steps: perStepSummary,
        numberOfSteps: numberOfSteps,
        currentStepIndex: currentStepIndex,
        currentStepProps: currentStepProps,
        previousStepIndex: previousStepIndex,
        nextStepIdOverride: _this.state.nextStepIdOverride,
        previousStepIdOverride: _this.state.previousStepIdOverride
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "transitionToStep", function (_ref3) {
      var stepId = _ref3.stepId,
          transitionName = _ref3.transitionName,
          transitionTimeout = _ref3.transitionTimeout,
          nextStepIdOverride = _ref3.nextStepIdOverride,
          previousStepIdOverride = _ref3.previousStepIdOverride;

      _this.setState({
        transitionName: transitionName,
        transitionTimeout: transitionTimeout,
        isTransitioning: true
      }, function () {
        try {
          _this.goToStep({
            stepId: stepId,
            nextStepIdOverride: nextStepIdOverride,
            previousStepIdOverride: previousStepIdOverride
          });
        } finally {
          _this.setState({
            isTransitioning: false
          });
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      registerStepListImplRef: _this.registerStepListImplRef,
      stepListImplRef: undefined,
      currentStepId: _this.props.initialStepId,
      nextStepIdOverride: undefined,
      previousStepIdOverride: undefined,
      transitionName: undefined,
      transitionTimeout: undefined,
      isTransitioning: false,
      getStatus: _this.getStatus,
      goToStep: _this.goToStep,
      goToStepCallCount: 0,
      getStepIds: _this.getStepIds,
      getNextStepId: _this.getNextStepId,
      getPreviousStepId: _this.getPreviousStepId,
      beginTransition: _this.beginTransition,
      endTransition: _this.endTransition,
      transitionToStep: _this.transitionToStep,
      extendedStateByStepId: {
        debugNote: 'this is working'
      },
      setStepExtendedState: _this.setStepExtendedState,
      getStepExtendedState: _this.getStepExtendedState,
      unsetStepExtendedState: _this.unsetStepExtendedState
    });
    return _this;
  }

  (0, _createClass2.default)(Workflow, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0, _jsx2.default)(_WorkflowContext.WorkflowContext.Provider, {
        value: this.state
      }, void 0, this.props.children);
    }
  }]);
  return Workflow;
}(_react.default.Component);

(0, _defineProperty2.default)(Workflow, "Consumer", function (props) {
  return /*#__PURE__*/_react.default.createElement(_WorkflowConsumer.default, props);
});
(0, _defineProperty2.default)(Workflow, "StepList", function (props) {
  return /*#__PURE__*/_react.default.createElement(_WorkflowStepList.default, props);
});
(0, _defineProperty2.default)(Workflow, "Step", function (props) {
  return /*#__PURE__*/_react.default.createElement(_WorkflowStep.default, props);
});
(0, _defineProperty2.default)(Workflow, "StepIdButton", function (props) {
  return /*#__PURE__*/_react.default.createElement(_WorkflowStepIdButton.default, props);
});
(0, _defineProperty2.default)(Workflow, "NextButton", function (props) {
  return /*#__PURE__*/_react.default.createElement(_WorkflowNextButton.default, props);
});
(0, _defineProperty2.default)(Workflow, "PreviousButton", function (props) {
  return /*#__PURE__*/_react.default.createElement(_WorkflowPreviousButton.default, props);
});
(0, _defineProperty2.default)(Workflow, "DebugInfo", function (props) {
  return /*#__PURE__*/_react.default.createElement(_WorkflowDebugInfo.default, props);
});
Workflow.displayName = 'WorkflowV2';
var _default = Workflow;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/browser/workflow/impl/Workflow.js
// module id = 4406
// module chunks = 25